/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { number } from 'prop-types';
import { Table, Placeholder } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { getYearOlds, formatDate } from 'Helpers/date-utils';
import { isMNDRLite } from 'Helpers/consult-utils';
import { upperFirst } from 'lodash';
import { getConsultPatient } from 'Redux/modules/webChat/consult/actions';

import PatientItem from './PatientItem';

const Patient = ({ consultId, patientId, sourceType }) => {
  const dispatch = useDispatch();
  const patient = useSelector(state => state.webChat.consults.patient);
  const loadingStatus = useSelector(state => state.webChat.consults.status.loadPatient);
  const isLoading = loadingStatus === 0;

  useEffect(() => {
    if (consultId && patientId) {
      dispatch(getConsultPatient(consultId, patientId));
    }
  }, [consultId, patientId, dispatch]);

  if (isLoading) {
    return (
      <Table basic="very" celled={false}>
        <Table.Body>
          {[1, 2, 3, 4, 5, 6].map(item => (
            <Table.Row key={item}>
              <Table.Cell>
                <Placeholder>
                  <Placeholder.Line length="short" />
                </Placeholder>
              </Table.Cell>
              <Table.Cell>
                <Placeholder>
                  <Placeholder.Line length="medium" />
                </Placeholder>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  }

  if (!patient) {
    return null;
  }

  // Map API response to component props (keys are camelCase due to humps transformation)
  const {
    nric,
    dateOfBirth,
    genderAtBirth,
    drugAllergies,
    medicalCondition,
    issueCountry,
    fullName,
    firstName,
    lastName,
    phoneNumber,
  } = patient;

  const displayName = fullName || (firstName && lastName ? `${firstName} ${lastName}` : '');
  const phoneCountryCode = issueCountry?.phoneCountryCode || '';

  return (
    <Table basic="very" celled={false}>
      <Table.Body>
        <PatientItem label="Name" value={displayName} />
        <PatientItem label="NRIC" value={nric || 'N/A'} />
        <PatientItem label="Gender at Birth" value={upperFirst(genderAtBirth ?? 'N/A')} />
        {dateOfBirth && (
          <PatientItem
            label="DoB"
            value={`${formatDate(dateOfBirth)} (${getYearOlds(dateOfBirth)} years old)`}
          />
        )}
        <PatientItem label="Drug Allergy" value={drugAllergies || 'N/A'} />
        <PatientItem label="Medical Condition" value={medicalCondition || 'N/A'} />
        {isMNDRLite(sourceType) && phoneNumber && (
          <PatientItem label="Phone Number" value={`${phoneCountryCode} ${phoneNumber}`} />
        )}
      </Table.Body>
    </Table>
  );
};

Patient.propTypes = {
  consultId: number,
  patientId: number,
  sourceType: number,
};
Patient.defaultProps = {
  consultId: null,
  patientId: null,
  sourceType: -1,
};

export default Patient;
